module.exports = __webpack_public_path__ + "static/img/fullscreen-image_post-hero.e50c1eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media-articles/fullscreen-image_post-hero.png
// module id = Fpao
// module chunks = 0